import React, { useEffect } from "react";
import { Stores, useGlobalState } from "react-migration/lib/persistence/state";
import { router } from "src/js/router/react-router";
import ROUTES from "src/js/router/routes";
import { LetterStep } from "src/js/stores/letter";

import { ConfirmAndSendStep } from "./ConfirmAndSendStep";
import { DownloadLetterStep } from "./DownloadLetterStep";
import { LetterPreviewStep } from "./LetterPreviewStep";
import { OrderConfirmedStep } from "./OrderConfirmedStep";
import { SelectEditableRecipientsStep } from "./SelectEditableRecipientsStep";
import { TemplateEditorStep } from "./TemplateEditorStep";

export const Letters = () => {
  const [{ siteCardId }] = useGlobalState(Stores.site);
  const [{ currentStep, selectedStageId }] = useGlobalState(Stores.letter);

  useEffect(() => {
    if (!siteCardId && !selectedStageId) {
      router.push({
        name: ROUTES.SITES,
        query: {
          card_page: "letters",
        },
      });
    }
  }, []);

  switch (currentStep) {
    case LetterStep.FinishAndDownload:
      return <DownloadLetterStep />;
    case LetterStep.SelectRecipients:
      return <SelectEditableRecipientsStep />;
    case LetterStep.TemplateEditor:
      return <TemplateEditorStep />;
    case LetterStep.PreviewLetter:
      return <LetterPreviewStep />;
    case LetterStep.ConfirmAndSend:
      return <ConfirmAndSendStep />;
    case LetterStep.OrderConfirmed:
      return <OrderConfirmedStep />;
    default:
      return <React.Fragment />;
  }
};
